<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import AppMixin from '@groot-nodes/mixins/App';
    import SettingsMixin from '@groot-nodes/settings/mixins';
    import { isLink } from '@/helpers/helpers';

    export default {
        name: 'App',

        mixins: [
            AppMixin,
            SettingsMixin,
        ],

        /**
         * @inheritDoc
         */
        data() {
            return {
                oldHtml        : '',
                intervalPointer: null,
                timeoutPointer : null,
            };
        },

        /**
         * @inheritDoc
         */
        beforeUpdate() {
            if (this.intervalPointer) {
                clearInterval(this.intervalPointer);
            }

            if (this.timeoutPointer) {
                clearTimeout(this.timeoutPointer);
            }
        },

        /**
         * @inheritDoc
         */
        updated() {
            if (window.self !== window.top) {
                this.intervalPointer = setInterval(() => {
                    const appDiv = document.querySelector('#app').innerHTML;

                    if (appDiv !== this.oldHtml) {
                        window.parent.postMessage(
                            JSON.stringify({
                                event  : 'content-change',
                                payload: appDiv,
                            }),
                            process.env.VUE_APP_PARENT_ORIGIN,
                        );

                        this.oldHtml = appDiv;
                    }
                }, 100);

                this.timeoutPointer = setTimeout(() => {
                    clearInterval(this.intervalPointer);
                }, 1000 * 10);
            }
        },

        /**
         * @inheritDoc
         */
        mounted() {
            if (window.self !== window.top) {
                document.querySelector('body').addEventListener('click', (e) => {
                    const anchor = e.target.closest('a');
                    if (anchor !== null && !isLink(anchor.getAttribute('href'))) {
                        window.parent.postMessage(
                            JSON.stringify({ event: 'route-change', payload: anchor.getAttribute('href') }),
                            process.env.VUE_APP_PARENT_ORIGIN,
                        );
                    }
                }, false);
            }
        },
    };
</script>
